// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableWithSortPagtnWithTotBillable";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours=0;
let sumbillable=0;
let maxwidth="80vw";
const ListWorkSummaryViewSpent = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    workDate,
  }) => {
    const [thead] = useState([
     
      "Project",
      
       "Billable Hours",
      "No Leaves Conveyed to Client (Days)",
      "Holidays Availed",
       

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
   
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

   

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);



    useEffect(() => {
      sumhours=0;
      sumbillable=0;
      empTask.map((el) =>{
        sumhours = sumhours+el.hoursSpent;
        sumbillable =sumbillable+el.hoursBillable;
      });
      let trow = empTask.map((el) => ({
        Project: <div style={{width:'100px'}}>{el.projectName === null ? "" : el.projectName}</div>,
       "Hours Spent": <div style={{width:'120px'}}>{el.hoursSpent === null ? "" : el.hoursSpent}</div>,
       "No Leaves Conveyed to Client (Days)" :<div style={{width:'120px'}}>{workDate}</div>,
       "Holidays Availed":<div style={{width:'120px'}}>{workDate}</div>,
     
      }));
   
      setTrow(trow);
    }, []);
    
    return (
      <Fragment>
        <div className="fixed-header">
          <div>
        
            &nbsp;
          
            <div className="d-inline float-right ">
 
            </div>
          </div>
        </div>
        {/*  style={{ maxWidth: maxwidth, overflowY: "auto" }} */}
        <div className="">
      <TableWithSortPagtn thead={thead} trow={trow} pageSize={5} sumhours={sumhours} sumbillable={sumbillable}></TableWithSortPagtn>
    </div>
     
      </Fragment>
    );
  }
);

export default ListWorkSummaryViewSpent;
